// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3hBep","savePackageButton":"ClientWallet_savePackageButton__2m_dw"};